import { Box, SvgIcon, Tooltip } from '@mui/material';
import React, { forwardRef } from 'react';

import { palette } from '../../../assets/styles/themes/tokens';
import getMuiIcon from '../../../utils/getMuiIcon';

const arrowStyles = {
	position: 'absolute' as const,
	left: '-5px',
	top: '6px',
};

const popperStyles = {
	height: '22px',
	paddingTop: '5px',
};

interface MenuItemTooltipProps {
	title: string;
	children: React.ReactElement;
}

const Arrow = forwardRef<HTMLDivElement, unknown>((_, ref) => (
	<Box sx={arrowStyles} color={palette.components.tooltip.fill} ref={ref}>
		<SvgIcon component={getMuiIcon('arrowLeftTooltip')} />
	</Box>
));

const MenuItemTooltip = forwardRef<HTMLDivElement, MenuItemTooltipProps>(
	({ title, children }, ref) => (
		<Tooltip
			data-testid="menu-item-tooltip"
			title={title}
			placement="right"
			arrow
			PopperProps={{
				sx: {
					['& .MuiTooltip-tooltip']: popperStyles,
				},
			}}
			slots={{
				arrow: Arrow,
			}}
			ref={ref}
			slotProps={{
				popper: {
					modifiers: [
						{
							name: 'offset',
							options: {
								offset: [0, -4],
							},
						},
					],
				},
			}}
		>
			{children}
		</Tooltip>
	)
);

export default MenuItemTooltip;
